import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_gtm_833011e8 from 'nuxt_plugin_gtm_833011e8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtsocketio_1574cd28 from 'nuxt_plugin_nuxtsocketio_1574cd28' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_80352344 from 'nuxt_plugin_cookieuniversalnuxt_80352344' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_255bfab6 from 'nuxt_plugin_axios_255bfab6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'client')
import nuxt_plugin_navigationguards_575a6062 from 'nuxt_plugin_navigationguards_575a6062' // Source: ../plugins/navigation-guards (mode: 'all')
import nuxt_plugin_i18n_2ced00f4 from 'nuxt_plugin_i18n_2ced00f4' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_axios_57e7b5de from 'nuxt_plugin_axios_57e7b5de' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_timezone_cc6b888e from 'nuxt_plugin_timezone_cc6b888e' // Source: ../plugins/timezone.js (mode: 'all')
import nuxt_plugin_globalfilter_4e3ef29c from 'nuxt_plugin_globalfilter_4e3ef29c' // Source: ../plugins/global/global-filter.js (mode: 'all')
import nuxt_plugin_globalmethods_a98ff4f0 from 'nuxt_plugin_globalmethods_a98ff4f0' // Source: ../plugins/global/global-methods.js (mode: 'all')
import nuxt_plugin_routerTab_aacd87d0 from 'nuxt_plugin_routerTab_aacd87d0' // Source: ../plugins/routerTab (mode: 'all')
import nuxt_plugin_globalcomponents_1020d7be from 'nuxt_plugin_globalcomponents_1020d7be' // Source: ../plugins/global/global-components.js (mode: 'all')
import nuxt_plugin_numberprecision_fb8b3bd0 from 'nuxt_plugin_numberprecision_fb8b3bd0' // Source: ../plugins/number-precision.js (mode: 'all')
import nuxt_plugin_vuecookies_23059d18 from 'nuxt_plugin_vuecookies_23059d18' // Source: ../plugins/vue-cookies.js (mode: 'all')
import nuxt_plugin_iview_0600062e from 'nuxt_plugin_iview_0600062e' // Source: ../plugins/iview.js (mode: 'client')
import nuxt_plugin_iconfont_52817fb0 from 'nuxt_plugin_iconfont_52817fb0' // Source: ../assets/js/iconfont.js (mode: 'client')
import nuxt_plugin_message_4fa9f8d5 from 'nuxt_plugin_message_4fa9f8d5' // Source: ../plugins/message.js (mode: 'client')
import nuxt_plugin_worker_37e7be58 from 'nuxt_plugin_worker_37e7be58' // Source: ../plugins/worker.js (mode: 'client')
import nuxt_plugin_store_9429320a from 'nuxt_plugin_store_9429320a' // Source: ../plugins/store.js (mode: 'client')
import nuxt_plugin_vuepdf_163aeff5 from 'nuxt_plugin_vuepdf_163aeff5' // Source: ../plugins/vue-pdf (mode: 'client')
import nuxt_plugin_handleerror_56081fcf from 'nuxt_plugin_handleerror_56081fcf' // Source: ../plugins/handle-error.js (mode: 'all')
import nuxt_plugin_vueclipboard2_2830b72f from 'nuxt_plugin_vueclipboard2_2830b72f' // Source: ../plugins/vue-clipboard2.js (mode: 'client')
import nuxt_plugin_gtm_9103e0c8 from 'nuxt_plugin_gtm_9103e0c8' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_remainsettlement_fbdc0edc from 'nuxt_plugin_remainsettlement_fbdc0edc' // Source: ../plugins/remain-settlement.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Kilimall Seller Center","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Kilimall Merchant Center"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fimage.kilimall.com\u002Fkenya\u002Fkilimall_lite\u002Fjs\u002Fimage-compressor.min.js","charset":"UTF-8"},{"src":"https:\u002F\u002Fwchat.freshchat.com\u002Fjs\u002Fwidget.js"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-BNFYY7LNEQ","async":true},{"src":"\u002Fanalytics.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_gtm_833011e8 === 'function') {
    await nuxt_plugin_gtm_833011e8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_1574cd28 === 'function') {
    await nuxt_plugin_nuxtsocketio_1574cd28(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_80352344 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_80352344(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_255bfab6 === 'function') {
    await nuxt_plugin_axios_255bfab6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_navigationguards_575a6062 === 'function') {
    await nuxt_plugin_navigationguards_575a6062(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_2ced00f4 === 'function') {
    await nuxt_plugin_i18n_2ced00f4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_57e7b5de === 'function') {
    await nuxt_plugin_axios_57e7b5de(app.context, inject)
  }

  if (typeof nuxt_plugin_timezone_cc6b888e === 'function') {
    await nuxt_plugin_timezone_cc6b888e(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilter_4e3ef29c === 'function') {
    await nuxt_plugin_globalfilter_4e3ef29c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmethods_a98ff4f0 === 'function') {
    await nuxt_plugin_globalmethods_a98ff4f0(app.context, inject)
  }

  if (typeof nuxt_plugin_routerTab_aacd87d0 === 'function') {
    await nuxt_plugin_routerTab_aacd87d0(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_1020d7be === 'function') {
    await nuxt_plugin_globalcomponents_1020d7be(app.context, inject)
  }

  if (typeof nuxt_plugin_numberprecision_fb8b3bd0 === 'function') {
    await nuxt_plugin_numberprecision_fb8b3bd0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecookies_23059d18 === 'function') {
    await nuxt_plugin_vuecookies_23059d18(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iview_0600062e === 'function') {
    await nuxt_plugin_iview_0600062e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iconfont_52817fb0 === 'function') {
    await nuxt_plugin_iconfont_52817fb0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_message_4fa9f8d5 === 'function') {
    await nuxt_plugin_message_4fa9f8d5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_worker_37e7be58 === 'function') {
    await nuxt_plugin_worker_37e7be58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_store_9429320a === 'function') {
    await nuxt_plugin_store_9429320a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepdf_163aeff5 === 'function') {
    await nuxt_plugin_vuepdf_163aeff5(app.context, inject)
  }

  if (typeof nuxt_plugin_handleerror_56081fcf === 'function') {
    await nuxt_plugin_handleerror_56081fcf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclipboard2_2830b72f === 'function') {
    await nuxt_plugin_vueclipboard2_2830b72f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_9103e0c8 === 'function') {
    await nuxt_plugin_gtm_9103e0c8(app.context, inject)
  }

  if (typeof nuxt_plugin_remainsettlement_fbdc0edc === 'function') {
    await nuxt_plugin_remainsettlement_fbdc0edc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
